import { render, staticRenderFns } from "./CustomerInvoiceCostRevenueDetails.vue?vue&type=template&id=b0b88c6a"
import script from "./CustomerInvoiceCostRevenueDetails.vue?vue&type=script&lang=js"
export * from "./CustomerInvoiceCostRevenueDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports